import { useState, useEffect } from "react";

import { Button } from "@/components/button";

import TechnicsCard from "./technics-card";
import {
  TableList,
  TableListBody,
  TableListHeader,
  TableListPagination,
  TTableListHeaderItem,
} from "@/components/table-list";
import { Loader } from "@/components/loader";
import { useAppDispatch, useAppSelector } from "src/config/store";
import { useLocation, useNavigate } from "react-router-dom";
import { IdefaultSearchParams, TOrderBy } from "@/models/types";
import { defaultSearchParams, getQueryParamsFromUrl, setParamsToUrl } from "src/utils/search-utils";
import { PrivateRoute } from "@/layouts/private-route";
import { PageTopbar } from "@/components/page-topbar";
import { getTechnics } from "@/reducers/technics-search.reducer";
import { TechnicsEdit } from "./technics-edit";
import { openModal } from "@/reducers/modal-reducer";
import { defaultTechnic } from "src/utils/utils";

export const TechnicsSearch = () => {
  const dispatch = useAppDispatch();
  const technicsState = useAppSelector((state) => state.technicsSearch);

  const location = useLocation();
  const navigate = useNavigate();

  const [params, setParams] = useState<IdefaultSearchParams>(
    getQueryParamsFromUrl(defaultSearchParams, location)
  );

  const onNewTechnic = () => {
    dispatch(
      openModal({
        element: <TechnicsEdit technic={defaultTechnic} />,
        opt: { size: "xs", title: "Nuova tecnica" },
      })
    );
  };

  const onChangePage = (page: number) =>
    setParams({
      ...params,
      offset: params.size * page,
    });

  const getCurrentPage = Math.floor(params.offset / params.size);

  const onChangeSort = (sort: TOrderBy) => () =>
    setParams({
      ...params,
      orderBy: sort,
      order: params.order === "ASC" ? "DESC" : "ASC",
    });

  const tableHeader: TTableListHeaderItem[] = [
    {
      id: "title",
      name: "Titolo",
      onClick: onChangeSort("title"),
    },
    {
      id: "createdDate",
      name: "Data creazione",
      onClick: onChangeSort("createdDate"),
    },
    {},
  ];

  useEffect(() => {
    dispatch(getTechnics(params));
    setParamsToUrl(params, navigate);
  }, [params.orderBy, params.order, params.offset, params.size, technicsState.refresh]);

  useEffect(() => {
    setParams(getQueryParamsFromUrl(defaultSearchParams, location.search));
  }, [location.search]);

  return (
    <PrivateRoute>
      <>
        <PageTopbar title={"Tecniche"}>
          <div className="button-group ml-auto">
            <Button className="button md solid primary" onClick={onNewTechnic}>
              Nuova tecnica
            </Button>
          </div>
        </PageTopbar>
        {technicsState.loading && <Loader color="#000000" />}
        {technicsState.fetchFailure && "Errore caricamento dati"}
        {!technicsState.loading && technicsState.search?.length === 0 && "Nessun dato"}
        {technicsState.search?.length > 0 && (
          <>
            <TableList className="color-black">
              <TableListHeader items={tableHeader} sortBy={params.orderBy} sortDirection={params.order} />
              <TableListBody>
                {technicsState.search?.map((technic) => (
                  <TechnicsCard key={technic.ID} technic={technic} />
                ))}
              </TableListBody>
            </TableList>
            <TableListPagination
              activePage={getCurrentPage}
              paginate={onChangePage}
              itemsPerPage={params.size}
              totalItems={technicsState.count}
            />
          </>
        )}
      </>
    </PrivateRoute>
  );
};
